/** `false` cuando `performanceId` ya está en el registro de votos del
 * navegador (`voted_performances`, localStorage) — el formulario de voto
 * debe deshabilitarse mostrando "Ya has votado" (spec.md FR-014). */
export function isVoteEligible(votedPerformances: readonly string[], performanceId: string): boolean {
  return !votedPerformances.includes(performanceId)
}
